import { Box, Button, TextField } from '@mui/material';
import React from 'react';

import {
	Autosuggest,
	RewardAutosuggest,
	TextInput,
	UserAutosuggest
} from 'components';
import { REWARD_USER_STATUS } from 'lib/constants';

const AchievementForm = ({ achievement, isEditing, handleChange }) => {
	return (
		<Box container spacing={1}>
			<Box item xs={12} sm={12}>
				<UserAutosuggest
					value={achievement?.user?.id}
					label="User"
					name="user_id"
					placeholder="Select user"
					handleChange={handleChange}
				/>
			</Box>
			<Box item xs={12} sm={12}>
				<RewardAutosuggest
					value={achievement?.reward?.id}
					label="Reward"
					name="reward_id"
					placeholder="Select reward"
					handleChange={handleChange}
				/>
			</Box>
			<Box item xs={12} sm={12}>
				<TextInput
					value={achievement.points_achieved || ''}
					label="Points Achieved"
					name="points_achieved"
					placeholder="Points Achieved"
					handleChange={handleChange}
				/>
			</Box>
			<Box item xs={12}>
				<Autosuggest
					options={REWARD_USER_STATUS}
					value={achievement.status || []}
					label="Status"
					name="status"
					placeholder=""
					handleChange={handleChange}
				/>
			</Box>
		</Box>
	);
};

export default AchievementForm;
